import { useEffect, useState } from "react";
import API_BASE_URL from "../config";

export default function useCurrentUserAccess() {
  const [loading, setLoading] = useState(true);
  const [platformRole, setPlatformRole] = useState(null);
  const [platformPermissions, setPlatformPermissions] = useState([]);
  const [account, setAccount] = useState(null);
  const [accountRole, setAccountRole] = useState(null);
  const [accountPermissions, setAccountPermissions] = useState([]);

  useEffect(() => {
    const loadMe = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          setLoading(false);
          return;
        }

        const res = await fetch(`${API_BASE_URL}/api/me`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (!res.ok) {
          setLoading(false);
          return;
        }

        const data = await res.json();

        setPlatformRole(data.platformRole || null);
        setPlatformPermissions(Array.isArray(data.platformPermissions) ? data.platformPermissions : []);
        setAccount(data.account || null);
        setAccountRole(data.accountRole || null);
        setAccountPermissions(Array.isArray(data.accountPermissions) ? data.accountPermissions : []);
      } catch (err) {
        console.error("Failed to load current user access:", err);
      } finally {
        setLoading(false);
      }
    };

    loadMe();
  }, []);

  return {
    loading,
    platformRole,
    platformPermissions,
    account,
    accountRole,
    accountPermissions
  };
}